// ----------------------------------------------------------------------

function path(root: string, subLink: string) {
  return `${root}${subLink}`;
}

const ROOTS_APP = "/app";
const ROOTS_AUTH = "/auth";
const ROOTS_DASHBOARD = "";

// ----------------------------------------------------------------------

export const PATH_DASHBOARD = {
  root: ROOTS_DASHBOARD,
  landing: path(ROOTS_DASHBOARD, "/landing"),
  app: path(ROOTS_APP, "/app"),
  home: path(ROOTS_DASHBOARD, "/home"),
  categrey: path(ROOTS_DASHBOARD, "/categories"),
  testDriveProcess: path(ROOTS_DASHBOARD, "/test-drive-process"),
  bookNow: path(ROOTS_DASHBOARD, "/book-now"),
  productListPage: path(ROOTS_DASHBOARD, "/explore-car"),
  productDetail: path(ROOTS_DASHBOARD, "/car-detail"),
  myProfile: path(ROOTS_DASHBOARD, "/my-profile"),
  sellCar: path(ROOTS_DASHBOARD, "/sell-car"),
  wishlist: path(ROOTS_DASHBOARD, "/wishlist"),
  myOrders: path(ROOTS_DASHBOARD, "/my-orders"),
  beAnInvestor: path(ROOTS_DASHBOARD,'/be-an-investor')
};

export const PATH_AUTH = {
  login: path(ROOTS_AUTH, "/login"),
  signUp: path(ROOTS_AUTH, "/sign-up"),
  forgotPassword: path(ROOTS_AUTH, "/forgotPassword"),
  updatePassword: path(ROOTS_AUTH, "/updatePassword"),
};
